//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import CommonImg from '@/components/views/common_img'
import CollapseBtn from './_collapse_btn'

import { sendCtmEvtLog } from '@/utils/log'
export default {
    components: {
        CommonImg,
        CollapseBtn,
    },
    data() {
        return {
            is_show_all: false
        }
    },
    computed: {
        baseinfos() {
            if (this.house && this.house.house_info && this.house.house_info.length) {
                return this.is_show_all ? this.house.house_info.map(item => item) : this.house.house_info.slice(0, 5)
            }
            return []
        },
        showInfoCollapse () {
            return this.house.house_info && this.house.house_info.length > 5
        },
        show_qr () {
            const keys = ['surplus_houses_price', 'surplus_houses_presell_no', 'metros']
            let count = keys.filter(key => this.is_selling && this.house[key]).length
            if (this.house.house_info) {
                count += this.house.house_info.length > 2
            }
            return count
        },
        metros () {
            return this.house.metros && this.house.metros.length ? this.house.metros.map(item => {
                return {
                    name: item,
                    ongoing: item.indexOf('在建') > -1
                }
            }) : []
        },
        show_audio () {
            const { audios } = this.house
            return Boolean(audios && audios.length)
        },
        audio_url () {
            return `/pages/building/audio/main?building_id=${this.house.id}`
        }
    },
    methods: {
        showAllInfo (is_show_all) {
            this.is_show_all = is_show_all
        }
    },
    props: {
        show_price_desc: {
            type: Boolean
        },
        house: {
            type: Object,
            default: {}
        },
        is_business: {
            type: Boolean,
            default: false
        },
        is_selling: {
            type: Boolean,
            default: false
        },
        show_surplus_houses: {
            type: Boolean,
            default: false
        }
    }
}
